module.exports = __webpack_public_path__ + "img/slide-2-explore-an-interactive.430eb51e.png";